"use strict";

exports.__esModule = true;
exports.updateFieldInLayoutElement = void 0;
var updateFieldInLayoutElement = exports.updateFieldInLayoutElement = function updateFieldInLayoutElement(config, path, fieldName, fieldValue) {
  var updatedConfig = Object.assign({}, config);
  var valueToUpdate = updatedConfig.element;
  path.forEach(function (element) {
    valueToUpdate = valueToUpdate[element];
  });
  valueToUpdate.props[fieldName] = fieldValue;
  return updatedConfig;
};